// @flow
import { deleteCreator, getCreator, postCreator, putCreator } from '../../http';
import environment from '../../environment';

import type { Country } from '../../entities';

export type PostItemRequestApi = {
  amount: number;
  detail?: string;
  image?: string;
  imageId?: string;
  imageURI?: string;
  itemCategoryId: number;
  itemId?: number;
  name: string;
  originalPackaging: boolean;
  price: string;
  shipping?: string;
  url: string;
  volumeTier: string;
  weight?: string;
  serviceTier?: string;
  courierId?: string;
};

export type PostBagRequestApi = {
  country: Country;
  items: PostItemRequestApi[];
  originType?: string;
};

export const endpoints = Object.freeze({
  GET_BAG: `${environment.apiUrl}/bag/:id`,
  POST_BAG: `${environment.apiUrl}/bag`,
  POST_BAG_ITEM: `${environment.apiUrl}/bag/:bagId`,
  PUT_BAG_ITEM: `${environment.apiUrl}/bag/:bagId/:numberId`,
  DELETE_BAG_ITEM: `${environment.apiUrl}/bag/:bagId/:numberId`,
});

export const getBagApi = getCreator(fetch, endpoints.GET_BAG);
export const postBagApi = postCreator(fetch, endpoints.POST_BAG);
export const postBagItemApi = postCreator(fetch, endpoints.POST_BAG_ITEM);
export const putBagItemApi = putCreator(fetch, endpoints.PUT_BAG_ITEM);
export const deleteBagItemApi = deleteCreator(fetch, endpoints.DELETE_BAG_ITEM);



// WEBPACK FOOTER //
// ./src/modules/bag/api.js